import React from "react";
import { VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import AudienceListItem from "../../AudienceListItem";
import { SocialIcon, LookalikeIcon } from "../../AudienceIcons";
import { StepProps, PageLookalikeAudienceFormValues } from "../types";

const AudienceTypeStep: React.FC<StepProps> = () => {
  const form = useFormContext<PageLookalikeAudienceFormValues>();
  const audienceMode = form.watch("audienceMode");
  const pageType = form.watch("pageType");

  const options = [
    {
      title: "Create page audience",
      description:
        pageType === "instagram"
          ? "Reach people who engaged with your Instagram account"
          : "Reach people who engaged with your Facebook page",
      value: "engagers",
      icon: <SocialIcon />,
      iconBgColor: "#DFEAFD",
      isRecommended: true,
    },
    {
      title: "Create lookalike audience",
      description:
        "Reach new people who are similar to your existing followers",
      value: "lookalike",
      icon: <LookalikeIcon />,
      iconBgColor: "#FDF5DF",
      isRecommended: false,
    },
  ];

  return (
    <VStack spacing={3} align="stretch">
      {options.map((option) => (
        <AudienceListItem
          key={option.value}
          title={option.title}
          description={option.description}
          icon={option.icon}
          iconBgColor={option.iconBgColor}
          value={option.value}
          isSelected={audienceMode === option.value}
          onSelect={(value) =>
            form.setValue("audienceMode", value as "engagers" | "lookalike")
          }
          isRecommended={option.isRecommended}
          showRadio={true}
          showPlus={false}
        />
      ))}
    </VStack>
  );
};

export default AudienceTypeStep;
